/**
 * This function attaches a drawer that executes a function on click.
 */

import { gebi } from '@js/utils/toolbox';

export class Drawer {
	/**
     * @param {string} name
     * @param {string} cta
     * @param {function} callBack
	 * @param {Object[]} alternativeFunctions [{name, classname, callback}]
     * @returns {Drawer}
     */
	constructor (name, cta = 'Click this!', showInMobile = true, callBack, alternativeFunctions) {
		if (typeof callBack !== 'function') {
			console.error('Error initializing drawer: Callback is not a function');
		} else {
			this.name = name;
			this.cta = cta;
			this.showInMobile = showInMobile;
			this.callBack = callBack;
			this.alternativeFunctions = alternativeFunctions;
			this.drawerEl = undefined;
			this.drawerButton = undefined;
		}

		this.createDrawer();
	}

	createDrawer () {
		const html = `<div id="drawer" class="drawer ${this.name} ${this.showInMobile ? 'show-in-mobile' : 'hide-in-mobile'}">
			${this.alternativeFunctions ? `<div class="drawerButton-container">${this.alternativeFunctions?.map(alternative => this.getAdditional(alternative)).join('')}</div>` : ''}
            <button id="drawer-button" class="abBtn abBtn--yellowBlue drawerButton" aria-label=${this.cta}>${this.cta}</button>
        </div>`;
		document.body.insertAdjacentHTML('beforeend', html);

		this.drawerEl = gebi('drawer');
		this.drawerButton = gebi('drawer-button');

		this.drawerButton.addEventListener('click', this.callBack);
	}

	getAdditional (alt) {
		if (typeof alt.name === 'string'
		&& typeof alt.dataAttribute === 'string') {
			return `<button id="drawer-button-${alt.name}" class="drawerButton-alt" data-action="${alt.dataAttribute}" aria-label=${alt.text}>${alt.text}</button>`;
		} else {
			return '';
		}
	}

	destroyDrawer () {
		this.drawerEl.remove();
	}

	updateDrawer (cta = 'Click this!', quantity = 0) {
		this.drawerButton.innerHTML = cta;
		this.drawerButton.ariaLabel = cta;
		this.drawerButton.dataset.qty = quantity;

		if (quantity) {
			this.drawerEl.classList.add('fill');
		} else {
			this.drawerEl.classList.remove('fill');
		}

		this.drawerEl.classList.remove('justUpdated');

		setTimeout(() => {
			this.drawerEl.classList.add('justUpdated');
		}, 0);
	}
}
